<template>
  <div class="navigation-button">
    <div class="button-content" @click="$emit('navigate-clicked')">
      <div class="button-and-text">
        <div class="button-image-wrapper">
          <img :src="require(`@/assets/${imagePath}`)" class="image"/>
          <lottie-player v-if="!!lottiePath" class="animation"
                         :src="JSON.stringify(require(`@/assets/${lottiePath}`))" :loop="true" :autoplay="true"/>
        </div>
        <span class="button-text">
        <span v-if="showNewBadge" class="is-new-banner">חדש!</span>
        {{ buttonText }}
      </span>
      </div>
      <span v-if="showExpand" class="fa fa-chevron-left chevron"></span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavigationButton',
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    imagePath: {
      type: String,
      required: true,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showNewBadge: {
      type: Boolean,
    },
    lottiePath: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .navigation-button {
    height: 80px;
    font-size: 16px;
    cursor: pointer;
    &:not(:last-of-type) {
      border-bottom: solid 1px $riseup-gray_0;
    }

    .button-content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .button-and-text {
        display: flex;
        align-items: center;
        .button-image-wrapper {
          position: relative;
          .image {
            width: 32px;
            height: 32px;
          }
          .animation {
            position: absolute;
            top: 0;
            width: 32px;
            height: 32px;
          }
        }

        .button-text {
          margin-right: 14px;
          position: relative;
          .is-new-banner {
            @include is-new-banner;
          }
        }
      }
      .chevron {
        font-size: 10px;
      }
    }
  }
</style>
